// send-budget-signature / send-contract-signature answer 200 even when some
// e-mails bounced ({ success: false, failed: n }). The signers exist either
// way, so it is not an error — but the operator must know some links did not
// go out, instead of a green "enviada!" toast.

export interface SignatureSendResult {
  success?: boolean;
  sent?: number;
  failed?: number;
}

export interface SignatureSendOutcome {
  ok: boolean;
  message: string;
}

export function signatureSendOutcome(
  data: SignatureSendResult | null | undefined,
): SignatureSendOutcome {
  const failed = data?.failed ?? 0;
  if (!data || (data.success !== false && failed === 0)) {
    return { ok: true, message: "Solicitação de assinatura enviada!" };
  }
  const sent = data.sent ?? 0;
  const plural = failed === 1 ? "e-mail não foi enviado" : "e-mails não foram enviados";
  return {
    ok: false,
    message: `Signatários criados, mas ${failed} ${plural}${sent ? ` (${sent} enviado${sent === 1 ? "" : "s"})` : ""}. Copie o link de assinatura e envie manualmente.`,
  };
}
